/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2023. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
const ID = {
  VIEW_YOUR_BENEFITS_CARD_ID: 'home-page-apply-for-benefits-link',
  VIEW_YOUR_ACCOUNT_CARD_ID: 'home-page-dashboard-link',
  FIND_HELP_NAV_ITEM_ID: 'navigation-find-help',
  YOUR_ACCOUNT_NAV_ITEM_ID: 'navigation-your-account',
  CONTACT_US_NAV_ITEM_ID: 'navigation-contact-us',
  FAQ_NAV_ITEM_ID: 'navigation-faqs',
  HOME_NAV_ITEM_ID: 'navigation-home',
  BENEFITS_NAV_ITEM_ID: 'navigation-benefits',
  FIRST_LANGUAGE_OPTION_ID: 'dropdown-language-0',
  HOME_PAGE_SECTION_ID: 'home-page-section',
  HOME_PAGE_CHECK_WHAT_YOU_MIGHT_GET_ID: 'home-page-check-what-you-might-get-link',
};

/* eslint-disable import/prefer-default-export */
export { ID };
